import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AccMappingTypes } from 'src/app/shared/models/accmapping.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  constructor(
    private http: HttpClient
  ) { }

  async encryptAccountMappingPayload(payload: AccMappingTypes): Promise<any> {
    const accMappingEncryption = environment.openbridgeApiUris.service + '/service/encrypt/accmapping_enc';
    return await this.http.post(accMappingEncryption, payload).toPromise();
  }

  async encryptStringList(payloadObject: {}): Promise<any> {

    const payload: StringsEncryptRequest = {
      data: {
        attributes: payloadObject
      }
    };

    const encryptUri = environment.openbridgeApiUris.service + '/service/encrypt/encrypt';
    const encryptResponse =  await this.http.post(encryptUri, payload).toPromise();
    return encryptResponse;
  }
}

interface StringsEncryptRequest {
  data: {
    attributes: {};
  };
}

interface StringsDecryptRequest {
  'data': {
    attributes: {};
  };
}